import { configureStore } from '@reduxjs/toolkit'
// Or from '@reduxjs/toolkit/query/react'
import { setupListeners } from '@reduxjs/toolkit/query'
import { eventsApi } from '../services/events'
import { blogsApi } from '../services/blogs'

export const store = configureStore({
    reducer: {
        // Add the generated reducer as a specific top-level slice
        [blogsApi.reducerPath]: blogsApi.reducer,
        [eventsApi.reducerPath]: eventsApi.reducer,
    },
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(blogsApi.middleware, eventsApi.middleware),
})

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)